import './rate.scss';

import { calculateMonthlyPayment } from '@thesavingsgroup/utils/calculateMonthlyPayment';
import { toRateNumber } from '@thesavingsgroup/utils/toRateNumber';
import { useTranslation } from 'react-i18next';

import { locator } from '../../../testing/e2e-locator/locator';
import { RateProps } from './types/RateProps';

export const Rate = ({
  monthlyPaymentAmount,
  apr,
  term,
  calculateMonthlyPaymentAmount,
}: RateProps) => {
  const { t } = useTranslation();

  let rateMonthlyPaymentAmount = toRateNumber(monthlyPaymentAmount);
  const rateApr = toRateNumber(apr, 2);
  const rateTerm = toRateNumber(term);

  if (calculateMonthlyPaymentAmount) {
    rateMonthlyPaymentAmount = calculateMonthlyPayment({
      rate: rateApr / 100,
      numberOfPaymentsInMonths: rateTerm,
      amountFinanced: rateMonthlyPaymentAmount,
    });
  }

  return (
    <div className="rate-container" data-testid={locator.components.rate.root}>
      <div>
        <label>{t('rate.payment')}</label>
        <span data-testid={locator.components.rate.paymentAmount}>
          {t('rate.monthlyPaymentAmount', { amount: rateMonthlyPaymentAmount })}
        </span>
      </div>

      <div>
        <label>{t('rate.apr')}</label>
        <span data-testid={locator.components.rate.aprPercent}>
          {t('rate.aprPercent', { percent: rateApr })}
        </span>
      </div>

      <div>
        <label>{t('rate.term')}</label>
        <span data-testid={locator.components.rate.termMonths}>
          {t('rate.termMonths', { months: rateTerm })}
        </span>
      </div>
    </div>
  );
};
